import { isAllowedHostname, parseUrl } from "../url-util";

export default function redirectToApp(refererUrl: string) {
  const url = parseUrl(refererUrl);

  if (url && isAllowedHostname(url.hostname)) {
    location.href = url.href;
    return;
  }

  location.href = DEFAULT_REDIRECTION_URL;
}
